/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInner,
  UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerFromJSON,
  UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerFromJSONTyped,
  UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerToJSON
} from './UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInner'

/**
 *
 * @export
 * @interface UpdateContactSettingRequestContactSettingFieldsInner
 */
export interface UpdateContactSettingRequestContactSettingFieldsInner {
  /**
   *
   * @type {string}
   * @memberof UpdateContactSettingRequestContactSettingFieldsInner
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof UpdateContactSettingRequestContactSettingFieldsInner
   */
  name?: string
  /**
   *
   * @type {Array<UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInner>}
   * @memberof UpdateContactSettingRequestContactSettingFieldsInner
   */
  contactSettingFieldItems?: Array<UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInner> | null
}

export function UpdateContactSettingRequestContactSettingFieldsInnerFromJSON(
  json: any
): UpdateContactSettingRequestContactSettingFieldsInner {
  return UpdateContactSettingRequestContactSettingFieldsInnerFromJSONTyped(json, false)
}

export function UpdateContactSettingRequestContactSettingFieldsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateContactSettingRequestContactSettingFieldsInner {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    contactSettingFieldItems: !exists(json, 'contact_setting_field_items')
      ? undefined
      : json['contact_setting_field_items'] === null
      ? null
      : (json['contact_setting_field_items'] as Array<any>).map(
          UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerFromJSON
        )
  }
}

export function UpdateContactSettingRequestContactSettingFieldsInnerToJSON(
  value?: UpdateContactSettingRequestContactSettingFieldsInner | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    contact_setting_field_items:
      value.contactSettingFieldItems === undefined
        ? undefined
        : value.contactSettingFieldItems === null
        ? null
        : (value.contactSettingFieldItems as Array<any>).map(
            UpdateContactSettingRequestContactSettingFieldsInnerContactSettingFieldItemsInnerToJSON
          )
  }
}
